import { IGameState } from "State/Game/IGameState";
import { PopupID } from "State/UI/PopupID";

export const STORE_ENTRY_POINT_TYPES = {
    MAP: 'map',
    SHOP: 'SHOP',
    PRIZE_WHEEL: 'PRIZE_WHEEL',
} as const;

export type RecordValues<T extends Record<string, string>> = T extends Record<string, infer U> ? U : never;
export type StoreEntryPoint = RecordValues<typeof STORE_ENTRY_POINT_TYPES>;

export function getStoreEntryPoint(state: IGameState): StoreEntryPoint {
    if (state.UIState.popupID === PopupID.WHEEL) return STORE_ENTRY_POINT_TYPES.PRIZE_WHEEL;
    if (state.UIState.popupID === PopupID.SHOP_MENU) return STORE_ENTRY_POINT_TYPES.SHOP;
    
    return STORE_ENTRY_POINT_TYPES.MAP;
}
